import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { lastValueFrom, map } from 'rxjs';
import { GcpDatabaseUserControllerService } from 'src/app/admin-api';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

interface PermissionOption {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-db-user-permissions-modal',
  templateUrl: './db-user-permissions-modal.component.html',
  styleUrls: ['./db-user-permissions-modal.component.scss']
})
export class DbUserPermissionsModalComponent implements OnInit {
  private dbUserService = inject(GcpDatabaseUserControllerService);
  user: { userId: number | null; displayName: string; dbUsername: string };
  loading = true;

  permissionOptions: PermissionOption[] = [
    { label: 'SELECT', value: 'SELECT', checked: false },
    { label: 'INSERT', value: 'INSERT', checked: false },
    { label: 'UPDATE', value: 'UPDATE', checked: false },
    { label: 'DELETE', value: 'DELETE', checked: false }
  ];

  constructor(
    private config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {
    this.user = this.config.data.user;
  }

  async ngOnInit(): Promise<void> {
    LoaderService.showLoader();
    try {
      const detail = await lastValueFrom(
        this.dbUserService
          .getDatabaseUser(this.user.userId as number)
          .pipe(map((data) => data.result))
      );
      this.permissionOptions.forEach((opt) => {
        opt.checked = detail?.permissions?.includes(opt.value) ?? false;
      });
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    }
    this.loading = false;
    LoaderService.showLoader(false);
  }

  async submit(): Promise<void> {
    LoaderService.showLoader();
    const selected = this.permissionOptions
      .filter((o) => o.checked)
      .map((o) => o.value) as ('SELECT' | 'INSERT' | 'UPDATE' | 'DELETE')[];
    try {
      await lastValueFrom(
        this.dbUserService.updatePermissions(
          {
            permissions: selected
          },
          this.user.userId as number
        )
      );
      this.ref.close(true);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    }
    LoaderService.showLoader(false);
  }
}
